import React from 'react'
import DemoInputsSection from '../DemoInputsSection'
import DemoInputTextAreaSimple from './DemoInputTextAreaSimple'

const DemoInputTextArea = () => {

  return (
    <DemoInputsSection name="textarea">
      <DemoInputTextAreaSimple/>
    </DemoInputsSection>
  )
}

export default DemoInputTextArea